const Error404 = () => {
    return <section className="max-w-screen-xl mx-auto">
        <div className="p-8 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-56 h-56 mx-auto my-4 text-slate-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
            </svg>

            <h1 className="text-9xl text-slate-500 font-medium my-4">404</h1>

            <p className="text-gray-600 text-center">Oops! This isn’t the page you’re looking for.</p>
            <p className="text-gray-600 mt-2 text-center">The page you are looking for appears to have been moved, deleted or does not exist.</p>

            <div className="my-8">
                <a href="/" className="hover:no-underline px-5 py-3 text-base font-medium text-center text-white rounded-full bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                    Go back home
                </a>
            </div>
        </div>
    </section>
}

export default Error404;